<template>
  <Menu placement="auto-start">
    <slot></slot>

    <template #popper>
      <div v-if="!Array.isArray(info?.[0])">
        <template v-for="({ label, value }, index) in info" :key="index">
          <p
            v-if="typeof value === 'number' && !Number.isNaN(value)"
            class="flex"
          >
            <span class="text-neutral-80 text-xs q-mr-xs">
              {{ label }}
            </span>
            <span class="text-xs">
              {{ numberFormat({ number: value, style: "currency" }) }}
            </span>
          </p>
          <div v-else class="flex" :style="{ maxWidth: '230px' }">
            <span class="text-neutral-80 text-xs">
              {{ label }}
              &nbsp; {{ info.length - 1 == index ? " &nbsp;&nbsp;" : "" }}
            </span>
            <div class="col">
              <span class="text-xs text-pre-line">
                {{ value }}
              </span>
            </div>
          </div>
        </template>
      </div>
      <div v-else>
        <template v-for="(infoItem, index) in info" :key="index">
          <div class="q-mb-xs">
            <div v-for="({ label, value }, idx) in infoItem" :key="idx">
              <div
                v-if="typeof value === 'number' && !Number.isNaN(value)"
                class="flex"
              >
                <span class="text-neutral-80 text-xs q-mr-xs">
                  {{ label }}
                </span>
                <span class="text-xs">
                  {{ numberFormat({ number: value, style: "currency" }) }}
                </span>
              </div>
              <div v-else>
                <span class="text-neutral-80 text-xs q-mr-xs">
                  {{ label }}
                </span>
                <span class="text-xs">
                  {{ value }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </Menu>
</template>

<script setup>
import { Menu } from "floating-vue";
import "floating-vue/dist/style.css";

import { numberFormat } from "assets/scripts/utilities/helpers";

defineProps({
  info: {
    type: Object,
    required: true,
  },
});
</script>
